module.exports = __webpack_public_path__ + "static/media/image-ftu-add-client.3db18a91.png";